import { type CompanyConfig, TimeFormat } from '../interface';

export const MCosmeticConfig: CompanyConfig = {
  id: '8f512eec-0d99-46da-964f-b932885f3e2b',
  lang: 'ru',
  langs: ['uz', 'ru'],
  name: 'MCosmetic',
  nameSecondary: 'MCosmetic',
  currency: 'UZS',
  currencyCode: 'UZS',
  officialName: 'MCosmetic',
  phonePlaceholder: '+998',
  defaultPhoneCode: '+998',
  ageRestricted: 0,
  timeZone: 'Asia/Tashkent',
  minimalOrderFeeThreshold: 700,
  canonical: '',
  defaultVolumeDisplay: '1x',
  countryCode: 'UZ',
  phoneNumber: '+998712030020',
  warehouse: {
    default: 'ECOSM',
    minimalOrderFeeWarehouseCodes: [],
    location: { lat: 41.2397833, lng: 69.3171977 },
  },
  map: {
    center: { lat: 41.309924509203256, lng: 69.24204007400306 },
    zoom: 12,
  },
  paymentMethods: ['visa', 'mc', 'cash'],
  availablePaymentMethods: ['octo'],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
    instagram: 'https://www.instagram.com/mcosmetic_uz/',
    tg: 'https://t.me/mcosmeticuz',
  },
  referral: {
    code: '',
    discount: '',
    minBasket: '',
    downloadAppLink: '',
  },
  appStoreUrl: {
    ios: '',
    android: '',
  },
  apis: {},
  license: {
    name: 'MCosmetic',
    numberPrinary: '',
  },
};
